var convert = require('xml-js');

export async function xmlToJs(xml) {

    try {
        var result1 = convert.xml2json(xml, {compact: true, spaces: 4});

        let json = JSON.parse(result1.toString())

        return json
    } catch (err) {
        return false
    }


}